import { useRef } from 'react';
import Lottie from 'lottie-react';

import { useChatUI } from '@atom/components/chat/hooks/useChatUI';
import animationData from '@atom/components/common/svgIcons/aiChatbotAnimatedButton.json';
import { IconButton } from '@atom/mui';

import classes from './askAIButton.module.css';

const styles = {
  askButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    margin: '0 0.5rem 0 0',
    padding: '0.25rem 0.5rem 0.25rem 0.25rem',
    borderRadius: '32px',
  },
  lottieIcon: {
    height: '32px',
    width: '32px',
  },
};

const AskAIButton = () => {
  const { toggleChatOpen } = useChatUI();

  const lottieRef = useRef(null);

  const handleClick = () => {
    toggleChatOpen();
  };

  const handleMouseEnter = () => {
    if (lottieRef.current) {
      lottieRef.current.play();
    }
  };

  const handleMouseLeave = () => {
    if (lottieRef.current) {
      lottieRef.current.goToAndStop(0, true);
    }
  };

  return (
    <div className={classes.askAiButtonContainer}>
      <IconButton
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        size="small"
        style={styles.askButton}
      >
        <Lottie
          lottieRef={lottieRef}
          animationData={animationData}
          loop
          autoplay={false}
          style={styles.lottieIcon}
        />
        <span className={classes.askAiText}>Ask AI</span>
      </IconButton>
    </div>
  );
};

export default AskAIButton;
